<template>
  <div>
    <!-- 头部 -->
    <div class="head-border">
      <div class="header">
        <img src="@/assets/img/shopvidi_logo.png" class="logo_img" @click="gotoShopvidi"/>
        <el-divider direction="vertical"></el-divider>
        <div class="header-content">Wholesale Partner Program</div>
      </div>
    </div>
    <!-- 主要内容框架 -->
    <div class="review-main-border">
      <div class="review-main">
        <el-steps
          class="pc-steps"
          :active="active"
          finish-status="success"
          align-center
        >
          <el-step title="Register"></el-step>
          <el-step title="Profile"></el-step>
          <el-step title="Review"></el-step>
        </el-steps>
        <div class="review-main-content" v-if="active === 2">
          <div class="review-main-content-title">Company and Location Details</div>
          <el-divider></el-divider>
          <div class="review-main-content-title">Company Details</div>
          <el-form :model="businessForm" ref="businessForm1" :rules="rules" class="business-form">
            <el-form-item prop="companyName" label="Company Name (Registered) ">
              <el-input v-model="businessForm.companyName" placeholder="eg.ShopVidi"></el-input>
            </el-form-item>
            <el-form-item prop="yearOfEstablishment" label="Year of Establishment">
              <el-input v-model="businessForm.yearOfEstablishment" placeholder="eg.1999"></el-input>
            </el-form-item>
            <el-form-item prop="companyWebsite" label="Company Website">
              <el-input v-model="businessForm.companyWebsite" placeholder="eg.www.shopvidi.com"></el-input>
            </el-form-item>
          </el-form>
          <div class="review-main-content-title">Company Address</div>
          <el-form :model="businessForm" ref="businessForm2" :rules="rules" class="business-form">
            <el-form-item prop="street" label="Street">
              <el-input v-model="businessForm.street" placeholder="eg.3427 Oakcliff Rd Ste 100"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="city" label="City">
                  <el-input v-model="businessForm.city" placeholder="eg.Doraville"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="state" label="State">
                  <el-input v-model="businessForm.state" placeholder="eg.Doraville"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="countryCode" label="Country">
                  <el-select
                    v-model="businessForm.countryCode"
                    filterable
                    placeholder="Enter Country"
                  >
                    <el-option
                      v-for="(item, index) in countryArr"
                      :label="item.text"
                      :value="item.value"
                      :key="index"
                    >
                      <span style="float: left">{{ item.text }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{
                        item.value
                      }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="zipCode" label="ZIP Code">
                  <el-input v-model="businessForm.zipCode" placeholder="eg.30340" maxlength="10"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="review-main-content-title">Industry Type</div>
          <el-form :model="businessForm" ref="businessForm3" :rules="rules" class="business-form">
            <el-form-item prop="categories" label="Categories">
              <el-select v-model="businessForm.categories" multiple placeholder="Please Choose" @change="chooseCategories">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="review-main-content-title">Brands Worked With In The Past</div>
          <div class="review-main-content-sub_title">Brands <span style="color:#F56C6C">*</span> (Brands I am hoping to cooperate with)</div>
          <div class="brands_img_border" v-if="brands && brands.length>0">
            <div class="brands_img" v-for="items in brands" :key="items.id" @click="selectedBrand(items)">
              <img :src="items.brandLogoUrl" class="brand_img"/>
              <img v-if="businessForm.selectedBrands && businessForm.selectedBrands.indexOf(items.id)>-1" src="@/assets/img/review_brand_right_top.png" class="brand_selected_img" />
            </div>
          </div>
          <div class="brands_img_border_text" v-else>Please choose the categories</div>
          <div class="tips_error" v-if="brandsMessage">Please choose the brands</div>
          <el-form :model="businessForm" ref="businessForm4" :rules="rules" class="business-form">
            <el-form-item prop="agencyTerritory" label="Agency Territory">
              <el-select v-model="businessForm.agencyTerritory" placeholder="Please Choose">
                <el-option
                  v-for="item in agencyTerritories"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="purchaseAmountMonth" label="Purchase amount/month">
              <el-select v-model="businessForm.purchaseAmountMonth" placeholder="Please Choose">
                <el-option
                  v-for="item in purchaseAmountMonths"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="ein" label="EIN">
              <el-input v-model="businessForm.ein" placeholder="eg.30340"></el-input>
            </el-form-item>
          </el-form>
          <div class="review-main-content-title">Documents Uploads</div>
          <div class="review-main-content-sub_title">Company Registered Address Proof <span style="color:#F56C6C">*</span></div>
          <img-swiper-review class="img_swiper" v-if="businessForm" :edit="true" :obj="businessForm" :imgListMessage="businessForm.companyRegisteredAddressProof" imgProperty="companyRegisteredAddressProof" id="1" />
          <div class="tips_error" v-if="companyRegisteredAddressProofMessage"> Please upload the Company Registered Address Proof</div>
          <div class="review-main-content-sub_title">Company Profile</div>
          <img-swiper-review class="img_swiper" v-if="businessForm" :edit="true" :obj="businessForm" :imgListMessage="businessForm.companyProfile" imgProperty="companyProfile" id="2" />

          <div class="review-main-content-sub_title">Qualification Certificate</div>
          <img-swiper-review class="img_swiper" v-if="businessForm" :edit="true" :obj="businessForm" :imgListMessage="businessForm.qualificationCertificate" imgProperty="qualificationCertificate" id="3" />

          <div class="review-main-content-action" v-loading="loading" @click="submit('businessForm')">Next</div>
        </div>
        <!-- 审核结果页面 -->
        <div class="review_result" v-if="active === 3">
          <img src="@/assets/img/in_review.png"/>
          <div class="review_result_title">In Review</div>
          <div class="review_result_tips">Your submitted information is currently under review. The audit will be completed within 48 hours.</div>
          <div class="review_result_action" @click="gotoHome">Back Home</div>
        </div>
      </div>
    </div>
    <home-footer/>
  </div>
</template>

<script>
import header from '../components/header.vue'
import { postAction, getAction } from '@/api/manage.js'
import ImgSwiperReview from '../components/img-swiper-review.vue'
import HomeFooter from '../components/home-footer'
import { loadSysRole } from '../../components/loadSysRole'
export default {
  components: { header, ImgSwiperReview, HomeFooter },
  data() {
    return {
      loading: false,
      countryArr: [],
      active: 2,
      isShowAction: false,
      businessForm: {
        companyName: '',
        yearOfEstablishment: '',
        companyWebsite: '',
        street: '',
        state: '',
        countryCode: '',
        zipCode: '',
        categories: [],
        selectedBrands: [],
        agencyTerritory: '',
        purchaseAmountMonth: '',
        ein: '',
        companyRegisteredAddressProof: [],
        companyProfile: [],
        qualificationCertificate: []
      },
      purchaseAmountMonths: [
        {value: 1, label: '< 10,000 USD'},
        {value: 2, label: '> 30,000 USD'},
        {value: 3, label: '> 50,000 USD'},
        {value: 4, label: '> 100,000 USD'},
        {value: 5, label: '> 150,000 USD'}
      ],
      agencyTerritories: [
        {value: 1, label: 'Northeast'},
        {value: 2, label: 'Midwest'},
        {value: 3, label: 'South'},
        {value: 4, label: 'West'},
        {value: 5, label: 'Pacific'},
        {value: 6, label: 'Mountain West'},
        {value: 7, label: 'Southwest'}
      ],
      rules: {
        companyName: [
          { required: true, message: 'Please enter the conpany name', trigger: ['blur', 'change'] }
        ],
        street: [
          { required: true, message: 'Please enter the street', trigger: ['blur', 'change'] }
        ],
        city: [
          { required: true, message: 'Please enter the city', trigger: ['blur', 'change'] }
        ],
        state: [
          { required: true, message: 'Please enter the state', trigger: ['blur', 'change'] }
        ],
        countryCode: [
          { required: true, message: 'Please enter the country', trigger: ['blur', 'change'] }
        ],
        zipCode: [
          { required: true, message: 'Please enter the zip code', trigger: ['blur', 'change'] }
        ],
        categories: [
          { required: true, message: 'Please choose the categories', trigger: ['blur', 'change'] }
        ],
        agencyTerritory: [
          { required: true, message: 'Please choose the Agency Territory', trigger: ['blur', 'change'] }
        ],
        purchaseAmountMonth: [
          { required: true, message: 'Please choose the Purchase amount/month', trigger: ['blur', 'change'] }
        ],
        ein: [
          { required: true, message: 'Please enter the EIN', trigger: ['blur', 'change'] }
        ]
      },
      options: [],
      brands: [],
      companyRegisteredAddressProofMessage: false,
      brandsMessage: false,
      updateAvatar: ''
    }
  },
  created() {
    this.getBusiness()
    this.getPhoneAndCountry()
    this.getCategories()
  },
  watch: {
    // 深度监听是否上传认证照片
    businessForm: {
      handler(n, o) {
        if (n.companyRegisteredAddressProof && n.companyRegisteredAddressProof.length > 0) {
          this.companyRegisteredAddressProofMessage = false
        } else {
          this.companyRegisteredAddressProofMessage = true
        }
      },
      deep: true
    }
  },
  methods: {
    getBusiness() {
      // 获取用户信息
      let userInfo = JSON.parse(localStorage.getItem('pro__userInfo')).value
      if (userInfo) {
        getAction('/brand/api/v0.2/businesses/' + userInfo.id).then(response => {
          if (response.success) {
            if (response.result.id) {
              if (response.result.reviewStatus !== 1) {
                this.active = 3
              }
              // 审核通过直接跳转进去
              if (response.result.reviewStatus === 1) {
                this.loadSysRole()
              }
            }
          }
        })
      }
    },
    loadSysRole() {
      loadSysRole(response => {
        const menuList = response
        let menu = menuList[0]
        if (menuList[0].childrenList && menuList[0].childrenList.length > 0) {
          menu = menuList[0].childrenList[0]
        }
        this.$router.push({path: 'menu/' + menu.key})
      })
    },

    gotoHome() {
      this.$router.push({path: '/'})
    },
    /**
     * 提交前校验
     */
    submit() {
      if (this.loading) {
        return
      }
      var form1 = false
      var form2 = false
      var form3 = false
      var form4 = false
      this.$refs['businessForm1'].validate(async (valid) => {
        if (valid) {
          form1 = true
        }
      })
      this.$refs['businessForm2'].validate(async (valid) => {
        if (valid) {
          form2 = true
        }
      })
      this.$refs['businessForm3'].validate(async (valid) => {
        if (valid) {
          form3 = true
        }
      })
      this.$refs['businessForm4'].validate(async (valid) => {
        if (valid) {
          form4 = true
        }
      })
      if (this.businessForm.selectedBrands && this.businessForm.selectedBrands.length === 0) {
        this.brandsMessage = true
      } else {
        this.brandsMessage = false
      }
      if (this.businessForm.companyRegisteredAddressProof && this.businessForm.companyRegisteredAddressProof.length === 0) {
        this.companyRegisteredAddressProofMessage = true
      } else {
        this.companyRegisteredAddressProofMessage = false
      }
      if (form1 && form2 && form3 && form4 && !this.brandsMessage && !this.companyRegisteredAddressProofMessage) {
        this.loading = true
        this.businessForm.countryCode = this.businessForm.countryCode.replace(/[^a-zA-Z]/g, '')
        postAction('/brand/api/v0.2/businesses', this.businessForm).then(response => {
          if (response.success) {
            // 成功后跳转到审核页面
            this.active = 3
            this.loading = false
          } else {
            this.$message.warning(response.message)
            this.loading = false
          }
        })
      }
    },
    handleFile(e) {
      let file = e.target.files[0]
      let formData = new FormData()
      formData.append('file', file)
      this.loading = true
      postAction('/common/service-orders', formData).then((res) => {
        if (res.code === 200) {
          // 上传成功后
          this.imgList.push(res.result)
          this.loading = false
          this.obj.imgList = this.imgList
          this.salesCompare(this.obj)
        } else {
          this.loading = false
          this.$message.error(res.message)
        }
      })
    },
    upload() {
      if (this.loading) { return false }
      if (this.imgList.length >= 11) {
        this.$message.error('maxLeng is 10')
        return false
      }
      if (this.maxLength !== 10 && this.imgList.length >= 31) {
        this.$message.error('maxLeng is 30')
        return false
      }
      document.getElementById(this.updateAvatar).click()
    },
    selectedBrand(item) {
      let index = this.businessForm.selectedBrands.indexOf(item.id)
      // 如果存在就删除
      if (index > -1) {
        this.businessForm.selectedBrands.splice(index, 1)
      } else {
        // 不存在就把元素插入
        this.businessForm.selectedBrands.push(item.id)
      }
      if (this.businessForm.selectedBrands && this.businessForm.selectedBrands.length === 0) {
        this.brandsMessage = true
      } else {
        this.brandsMessage = false
      }
    },
    getCategories() {
      getAction('/tsCategory/tsCateInfo/all-list').then(response => {
        if (response.success) {
          let tempCategories = []
          const categories = response.result
          for (var index = 0; index < categories.length; index++) {
            if (categories[index].barType === 'cate') {
              const category = {}
              category.label = categories[index].cateName
              category.value = categories[index].id
              tempCategories.push(category)
            }
          }
          this.options = tempCategories
        }
      })
    },
    chooseCategories(e) {
      this.brands = []
      if (e && e.length === 0) {
        this.businessForm.selectedBrands = []
        this.brandsMessage = true
        return
      }
      // TODO 根据分类查询品牌信息
      getAction('/brand/api/v0.2/brands?category_ids=' + e).then(response => {
        if (response.success) {
          this.brands = response.result
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    gotoShopvidi() {
      window.open('https://www.shopvidi.com')
    },
    // 获取国家、手机号配置信息
    getPhoneAndCountry() {
      getAction('/sys/dict/getDictItems/reg-country-config').then(response => {
        if (response.success) {
          if (response.result) {
            this.countryArr = response.result
            localStorage.setItem('allCountry', JSON.stringify(response.result))
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.review_result{
  width: 50%;
  margin: 0 auto;
  margin-top: 100px;
  text-align: center;
  .review_result_title{
    margin-top: 10px;
    height: 25px;
    font-size: 20px;
    font-family: Satoshi-Medium;
    font-weight: 500;
    line-height: 27px;
    color: #262B2F;
    opacity: 1;
  }
  .review_result_tips{
    margin-top: 26px;
    height: 47px;
    font-size: 14px;
    font-family: Satoshi-Regular;
    font-weight: 400;
    line-height: 20px;
    color: #262B2F;
    opacity: 1;
  }
  .review_result_action{
    height: 50px;
    width: 30%;
    border: 1px solid #E1E1E1;
    margin:0 auto;
    margin-top: 26px;
    border-radius: 5px;
    line-height: 50px;
    cursor: pointer;
  }
}
.tips_error{
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}
.review-main-content-action{
  width: 100%;
  margin:20px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #262B2F;
  color: white;
  height: 50px;
  cursor: pointer;
}
/deep/ .el-upload.el-upload--picture-card {
  background-color: #ffffff;
  border: 1px solid #c0ccda;
  border-color: #262b2f;
  font-size: 12px;
  font-weight: 600;
  line-height: 50px;
  border-radius: 0px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.brands_img_border_text{
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #E1E1E1;
  width: 100%;
  display: flex;
  height: 200px;
  padding: 20px;
  color:#8F8F8F
}
.brands_img_border{
  border: 1px solid #E1E1E1;
  width: 100%;
  display: flex;
  flex-flow:row wrap;
  overflow-x:hidden;
  height: 200px;
  margin-bottom: 20px;
  padding-top: 20px;
  align-items: center;
  justify-content: center;
  .brands_img{
    cursor: pointer;
    border: 1px solid #E1E1E1;
    height: 90px;
    width: 90px;
    margin: 15px 15px 15px 15px;
    position: relative;
    .brand_selected_img{
      position: absolute;
      z-index: 99;
      margin-left: -24px;
      width: 24px;
      height: 24px;
    }
  }
}
.head-border {
  position: fixed;
  background-color: #fff;
  height: 100px;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E1E1E1;
  .header{
    margin-left: 50px;
    display: flex;
    align-items: flex-end;
    .logo_img{
      height:45px;
      width:177px;
      cursor: pointer;
    }
    .el-divider--vertical{
      height:20px !important
    }
  }
  .header-action{
    display: flex;
    margin-right: 50px;
    .action{
      width:114px;
      height:44px;
      border: 1px solid black;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      cursor: pointer;
    }
    .action.black{
      background-color: black;
      color: white;
    }
  }
}
.review-main-border{
  width: 100%;
  margin-top: 150px;
  // border-top: 1px solid #E1E1E1;
  .review-main{
    width: 50%;
    margin:0 auto;
    margin-top: 70px;
    /* 步骤条样式修改 */
    /deep/ .el-step__title.is-wait {
      color: #8f8f8f !important;
      font-size: 14px;
      font-weight: 500;
      line-height: 30px;
      color: #8f8f8f;
      opacity: 1;
    }
    /deep/ .el-steps.el-steps--horizontal {
      width: 100%;
      margin: 0 auto;
      margin-top: 30px;
    }
    /deep/ .el-step__head.is-success {
      color: #FFFFFF !important;
      border-color: #000000 !important;
      .el-step__icon.is-text{
        background-color: #000000;
      }
    }
    /deep/ .el-step__title.is-success {
      color: #000000 !important;
      font-size: 14px;
      font-weight: 500;
      line-height: 30px;
      color: #262b2f;
      opacity: 1;
    }
    /deep/ .el-step__head.is-process {
      color: #8f8f8f !important;
      border-color: #8f8f8f !important;
    }
    /deep/ .el-step__title.is-process {
      color: #8f8f8f !important;
      font-size: 14px;
      font-weight: 500;
      line-height: 30px;
      color: #262b2f;
      opacity: 1;
    }
    /deep/ .el-divider.el-divider--horizontal{
      margin: 25px 0px ;
    }
    .review-main-content{
      width: 70%;
      margin:0 auto;
      padding-top: 60px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      .review-main-content-title{
        height: 30px;
        font-size: 14px;
        font-family: Satoshi-Medium;
        font-weight: 500;
        line-height: 30px;
        color: #262B2F;
        opacity: 1;
      }
      .review-main-content-sub_title{
        margin:20px 0px;
      }
      .business-form{
        width: 100%;
        margin-top: 20px;
        /deep/ .el-form-item__label{
          margin-bottom: 5px;
        }
        /deep/ .el-select{
          width: 100%;
        }
      }
    }
  }
}
/deep/ .el-form-item.is-required{
  .el-form-item__label::before{
    display: none;
  }
  .el-form-item__label:after{
    content: '*';
    color: #F56C6C;
    margin-left: 4px
  }
}

/deep/ .el-row{
  display: flex;
  justify-content: space-between;
}
.img_swiper{
  width: 100%;
}
@media screen and(max-width: 600px) {
  .review_result{
    width: 100%;
    margin: 0 auto;
    margin-top: 100px;
    text-align: center;
    .review_result_title{
      margin-top: 10px;
      height: 25px;
      font-size: 20px;
      font-family: Satoshi-Medium;
      font-weight: 500;
      line-height: 27px;
      color: #262B2F;
      opacity: 1;
    }
    .review_result_tips{
      margin-top: 26px;
      height: 47px;
      font-size: 14px;
      font-family: Satoshi-Regular;
      font-weight: 400;
      line-height: 20px;
      color: #262B2F;
      opacity: 1;
    }
    .review_result_action{
      height: 50px;
      width: 30%;
      border: 1px solid #E1E1E1;
      margin:0 auto;
      margin-top: 26px;
      border-radius: 5px;
      line-height: 50px;
      cursor: pointer;
    }
  }
  .brands_img_border{
    .brands_img{
      height: 53px;
      width: 53px;
      margin: 5px 5px 5px 5px;
      position: relative;
      .brand_selected_img{
        position: absolute;
        z-index: 99;
        top: 0;
        left: 52px;
      }
    }
  }

  .review-main-border{
    margin-top: 100px;
    .review-main{
      width: 90%;
      margin-top: 30px;
      .review-main-content{
        width: 100%;
      }
    }
  }
  .head-border{
    height: 50px;
    .header{
      margin-left: 10px;
      .logo_img{
        height:23px;
        width:90px;
        cursor: pointer;
      }
      .header-content{
        font-size: 10px;
        font-family: Satoshi;
        font-weight: 500;
        line-height: 20px;
        color: #262B2F;
        opacity: 1;
      }
    }
    .header-action{
      display: flex;
      margin-right: 10px;
      .action{
        width:60px;
        height:30px;
        border: 1px solid black;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .action.black{
        background-color: black;
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/review/review.vue